import { categoryConfig } from "./categoryConfig";
import "./CategoryList.css";

export default function CategoryList({ categories }) {
  return (
    <div className="list-group list-group-flush category-list">
      {categories.map((cat) => {
        const config = categoryConfig[cat.name] || {};

        return (
          <div
            key={cat.name}
            className="list-group-item category-item d-flex justify-content-between align-items-center border-0 px-3 py-3"
          >
            {/* Left Side */}
            <div className="d-flex align-items-center gap-3">
              <div
                className="icon-wrapper d-flex align-items-center justify-content-center rounded-circle"
                style={{
                  backgroundColor: config.color + "15",
                  color: config.color,
                }}
              >
                {config.icon}
              </div>

              <span className="fw-medium category-name">{cat.name}</span>
            </div>

            {/* Count Badge */}
            <span className="badge bg-light text-dark rounded-pill px-3 py-2 shadow-sm">
              {cat.productCount}
            </span>
          </div>
        );
      })}
    </div>
  );
}
